/* RLB — gentle scroll reveal for sections (fade + rise). Respects reduced-motion. */
(function () {
  if (typeof window === 'undefined') return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var sections = document.querySelectorAll('section[class*="rlb-"]');
    if (!sections.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('rlb-in'); });
      return;
    }

    sections.forEach(function (s) { s.classList.add('rlb-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rlb-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    sections.forEach(function (s) {
      var r = s.getBoundingClientRect();
      /* already in view on load → show immediately (no flash) */
      if (r.top < window.innerHeight * 0.92) { s.classList.add('rlb-in'); }
      else { io.observe(s); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
